import React, { useEffect, useRef } from "react";
import { getSetting } from "../../../settings";

const FeatureFeedback = ({ feature, customerName, userId = "", roleId = "", theme = "light", reDisplayAfterDays = 30, dismissible = true, showTooltip = false }: any) => {
    const product = getSetting("featureFeedbackProductName") || "";
    const apiHost = getSetting("featureFeedbackApiHost") || "";
    const accountToken = getSetting("featureFeedbackAccountToken") || "";
    const registryBase = getSetting("mfeRegistryBase") || "";

    const containerRef = useRef<any>(null);
    const renderedParamsRef = useRef("");

    // Build params string — only re-render OC component when params actually change
    const paramsString = JSON.stringify({
        feature, accountToken, apiHost, product, registryBase,
        customerName, userId, roleId,
        theme, reDisplayAfterDays, dismissible, showTooltip,
    });

    useEffect(() => {
        if (!containerRef.current || !registryBase || !customerName || !userId) return;
        if (renderedParamsRef.current === paramsString) return;

        renderedParamsRef.current = paramsString;

        const params = new URLSearchParams({
            feature,
            accountToken,
            apiHost,
            customerName,
            userId,
            product,
            roleId,
            theme,
            reDisplayAfterDays,
            dismissible,
            showTooltip,
        });

        const componentUrl = `${registryBase}/evo-feature-feedback-collector/1/?${params}`;

        const ocComponent = document.createElement("oc-component");
        ocComponent.setAttribute("href", componentUrl);
        ocComponent.style.setProperty("--feedback-icon-size", "16px");
        ocComponent.style.setProperty("--feedback-button-size", "20px");

        containerRef.current.innerHTML = "";
        containerRef.current.appendChild(ocComponent);

        if (window.oc && window.oc.renderUnloadedComponents) {
            window.oc.renderUnloadedComponents();
        }
    }, [paramsString]);

    return <div ref={containerRef} style={{ display: "inline-flex", alignItems: "center" }} />;
};

export default FeatureFeedback;
